import React from 'react';
import {
  ViewButton,
  ViewLeadButton,
  FacebookButton,
} from '../Common/DataTable/tableActionButtons';
import {
  getFilter,
  getLabel,
  getSort,
  userName,
} from '../Common/DataTable/tableHelpers';
import { capitalize } from '../../helpers/sharedFunction';
import moment from 'moment';

const printPayload = (cell) =>
  cell
    ? Object.keys(cell)
        .sort()
        .map((key) => `${key}: ${cell[key]}`)
        .join(',')
    : '';

const createTableColumns = (
  openLeadModal,
  openViewModal,
  openSendMetaCAPIAlert,
  monetizationOrders,
  acquisitionOrders,
  users,
  showSensitiveData,
  t,
) => {
  const actions =
    openLeadModal || openViewModal || openSendMetaCAPIAlert
      ? {
          title: 'Action',
          name: 'action',
          width: 140,
          align: 'center',
          formatterComponent: ({ row }) => (
            <ul className="list-inline font-size-20 contact-links mb-0">
              {openViewModal && (
                <ViewButton row={row} onPress={openViewModal} />
              )}
              {openLeadModal && (
                <ViewLeadButton row={row} onPress={openLeadModal} />
              )}
              {openSendMetaCAPIAlert && (
                <FacebookButton
                  row={row}
                  onPress={openSendMetaCAPIAlert}
                  label="Send Meta Conversion API Event"
                />
              )}
            </ul>
          ),
          filter: 'disabled',
          sorting: 'disabled',
        }
      : {
          title: 'Action',
          name: 'action',
          hidden: true,
          filter: 'disabled',
          sorting: 'disabled',
        };

  return [
    {
      title: 'AcquisitionOrder',
      name: 'acquisitionOrderId',
      getCellValue: (row) =>
        getLabel(row.acquisitionOrderId, acquisitionOrders),
    },
    {
      title: 'MonetizationOrder',
      name: 'monetizationOrderId',
      getCellValue: (row) =>
        getLabel(row.monetizationOrderId, monetizationOrders),
    },
    {
      title: 'Status',
      name: 'status',
      width: 120,
      formatterComponent: ({ value }) =>
        value === 'closed' ? (
          <span className="badge badge-success font-size-12">{t(value)}</span>
        ) : (
          <span className="badge badge-danger font-size-12">{t(value)}</span>
        ),
      sorting: (a, b) => getSort(t(a), t(b)),
      filter: (value, filter) => getFilter(t(value), filter.value),
    },
    {
      title: 'Scheduled',
      width: 120,
      name: 'scheduled',
      formatterComponent: ({ row }) =>
        row.scheduled ? (
          <span className="badge badge-success font-size-12">YES</span>
        ) : (
          <span className="badge badge-warning font-size-12">NO</span>
        ),
      filter: (value, filter, row) =>
        getFilter(row.scheduled ? 'YES' : 'NO', filter.value),
      hidden: true,
    },
    {
      title: 'Revenue',
      name: 'revenue',
      width: 80,
      formatterComponent: ({ value }) =>
        `€ ${showSensitiveData ? value : '**'}`,
      filter: showSensitiveData ? undefined : 'disabled',
      sorting: showSensitiveData ? undefined : 'disabled',
    },
    {
      title: 'Qualify Cost',
      name: 'qualifyCost',
      width: 100,
      formatterComponent: ({ value }) =>
        `€ ${showSensitiveData ? value : '**'}`,
      filter: showSensitiveData ? undefined : 'disabled',
      sorting: showSensitiveData ? undefined : 'disabled',
    },
    {
      title: 'Closure',
      width: 120,
      name: 'closure',
      formatterComponent: ({ row }) =>
        row.revenue > 0 ? (
          <span className="badge badge-success font-size-12">Positive</span>
        ) : (
          <span className="badge badge-danger font-size-12">Negative</span>
        ),
      filter: (value, filter, row) =>
        getFilter(row.revenue > 0 ? 'positive' : 'negative', filter.value),
      sorting: 'disabled',
    },
    {
      title: 'Attempts',
      name: 'attempts',
      width: 80,
      hidden: true,
    },
    {
      title: 'Error',
      name: 'error',
      width: 150,
      hidden: true,
    },
    {
      title: 'Positive Outcome',
      name: 'positiveOutcome',
      width: 150,
      hidden: true,
    },
    {
      title: 'Negative Outcome',
      name: 'negativeOutcome',
      width: 150,
      getCellValue: (row) =>
        row.negativeOutcome ? t(capitalize(row.negativeOutcome)) : '',
      hidden: true,
    },
    {
      title: 'Lead ID',
      name: 'leadId',
      hidden: true,
    },
    {
      title: 'Operator',
      width: 150,
      name: 'userId',
      sort: true,
      getCellValue: (row) => userName(row.userId, users),
    },
    {
      title: 'Payload',
      width: 150,
      name: 'payload',
      getCellValue: (row) => printPayload(row.payload),
      sorting: 'disabled',
      hidden: true,
    },
    {
      title: 'Sent At',
      name: 'sentAt',
      width: 120,
      getCellValue: (row) =>
        row.sentAt ? moment(row.sentAt).format('DD/MM/YYYY HH:mm') : '',
      hidden: true,
    },
    {
      title: 'Meta CAPI Event',
      name: 'metaCAPIEvent',
      width: 150,
      getCellValue: (row) =>
        row.metaCAPIEvent ? t(capitalize(row.metaCAPIEvent.status)) : '',
      hidden: true,
    },
    {
      title: 'Created At',
      name: 'createdAt',
      width: 120,
      formatterComponent: ({ value }) => t('date_fromNow', { date: value }),
      filter: (value, filter) =>
        getFilter(t('date_fromNow', { date: value }), filter.value),
      exportValue: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm:ss'),
    },
    actions,
  ];
};

export default createTableColumns;
